/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountQuery
 */
export interface AccountQuery {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountQuery
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the AccountQuery interface.
 */
export function instanceOfAccountQuery(value: object): value is AccountQuery {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function AccountQueryFromJSON(json: any): AccountQuery {
    return AccountQueryFromJSONTyped(json, false);
}

export function AccountQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function AccountQueryToJSON(json: any): AccountQuery {
    return AccountQueryToJSONTyped(json, false);
}

export function AccountQueryToJSONTyped(value?: AccountQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

